/**
 * Wherever this is imported, please ensure to have the Snackbar component as well.
 * As we are sending saved message from here.
 */

import axios from 'axios'
import {mapState, mapWritableState} from "pinia";
import {useGroupsStore} from "@/stores/GroupsStore";
import {findIndex} from "lodash";
import Vue from "vue";
import constants from "@/assets/js/constants";

// axios.defaults.baseURL = 'http://confixapi.dev.com';
// axios.defaults.baseURL = 'http://localhost:3111/api/'

if (window.location.hostname.indexOf('localhost') !== -1) {

    if (navigator.appVersion.indexOf('Win') != -1) {
        axios.defaults.baseURL = window.location.protocol + '//' + window.location.hostname + '/lightphone/api/'
    } else if (navigator.appVersion.indexOf('Mac') != -1) {
        // axios.defaults.baseURL = window.location.protocol + '//' + window.location.hostname + ':3111/api/'
        axios.defaults.baseURL = window.location.protocol + '//lightphone.dev.com/api/'

    } else if (navigator.appVersion.indexOf('Linux') != -1) {
        // After connecting rpi, the windows laptop also goes here.
        // axios.defaults.baseURL = window.location.protocol + '//' + window.location.hostname + ':3111/api/'
        axios.defaults.baseURL = window.location.protocol + '//lightphone.dev.com/api/'

    }

} else {
    axios.defaults.baseURL = window.location.protocol + '//' + window.location.host + '/api/'
}

export default {

    computed: {
        ...mapWritableState(useGroupsStore, {
            groups: 'groups',
            currentSelectedGroup: 'currentSelectedGroup',
            currentSelectedGroupName: 'currentSelectedGroupName',
        })
    },

    methods: {

        configGroupsHasDomainInDestDomainsAlready(key, domain) {

            let self = this;

            if (self.groupToAdd.includes('/')) {
                let [folder, group] = self.groupToAdd.split('/')
                let groupRow = self.groups.find(g => g.key === folder);
                let childRow = groupRow.child.find(c => c.key === group);
                return (childRow.value.dest_domains.includes(domain));
            } else {
                let index = findIndex(this.groups, {key})
                return (index !== -1) ? this.groups[index]['value']['dest_domains'].includes(domain) : false;
            }

        },


    }

}
